import store from '@/store/store';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { get } from '@/api/produit/produitReseauLc';
import { get as getProduitAssocie } from '@/api/produit/index';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import { CATEGORIE_REGROUPEMENT_LC, CATEGORIE_DIVERS } from '@/configuration/catalogue/produitConf';
import {
  REGROUPEMENT,
  ANNEE,
  TYPE_FACTURE,
  TYPE_DEVIS,
} from '@/configuration/devisConf';
import { getAffectionOfProductReseauLc, updateAffection } from '@/services/affectation/affectation';
import calculDateFin from '@/services/general/calculDateFin';
import { updateTarifProduitDiversTlpe, setPrixUnitaireTlpe } from '@/services/devisCommandes/updateTarifProduitDiversTlpe';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import setFournisseurIfNotRegie
  from '@/services/devisCommandes/bonAFacturer/setFournisseurIfNotRegie';
import setAFacturerOfLigne from '@/services/devisCommandes/bonAFacturer/setAFacturerOfLigne';
import getDisponibilite from '@/services/devisCommandes/getDisponibiliteTempo';
import { OPTION } from '@/configuration/optionBlocage/optionBlocage';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

function generationLigneCommandeRegroupement(
  produitReseau, produitsAssocies, dcf, tauxTva,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande);
  nouvelleLigneCommande.quantiteDispo = 1;
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitReseau.reference + ' - ' + produitsAssocies.libelle : produitReseau.reference;
  nouvelleLigneCommande.produitId = produitReseau.id;
  nouvelleLigneCommande.typeProduit = CATEGORIE_REGROUPEMENT_LC;
  nouvelleLigneCommande.produit = produitReseau;
  nouvelleLigneCommande.tauxTva = 0;
  nouvelleLigneCommande.dateDebut = dcf && dcf.datePremierAffichage || new Date();
  nouvelleLigneCommande.aIntegrerDansLaLogistique = produitReseau.logisticable;
  const dateFin = calculDateFin(
    nouvelleLigneCommande.dateDebut, produitsAssocies.quantite, produitsAssocies.uniteVente,
  );
  if (dateFin) {
    nouvelleLigneCommande.dateFin = dateFin;
  } else {
    nouvelleLigneCommande.dateFin = calculDateFin(nouvelleLigneCommande.dateDebut, 1, ANNEE);
  }
  nouvelleLigneCommande.libelle = produitReseau.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = REGROUPEMENT;

  if (produitsAssocies && produitsAssocies.produitEnfant) {
    nouvelleLigneCommande.lignesCommande = generationToutesLignesCommandes(
      produitsAssocies, tauxTva,
    );
  } else nouvelleLigneCommande.lignesCommande = [];

  // AJOUT D INFORMATION SUPPLEMENTAIRE EN FONCTION DE LA SOCIETE (REGIE, MANDATIARE ...)
  setFournisseurIfNotRegie(produitReseau, nouvelleLigneCommande);
  setAFacturerOfLigne(nouvelleLigneCommande, dcf);

  return nouvelleLigneCommande;
}

export async function mettreAJourLigneReseauAvecDispo(ligne) {
  const dispo = await getDisponibilite(ligne, ligne.dateDebut, ligne.dateFin);
  ligne.ligneReseau = {
    ...ligne.ligneReseau,
    anneeSemaine: dispo.anneeSemaine,
    jourDepart: dispo.jourDepart,
    qteFacesPrevues: dispo.stock,
    qteFacesSouhaitees: Math.ceil(dispo.stock - dispo.vendu),
    lignesCmdSelProduits: ligne.ligneReseau?.lignesCmdSelProduits?.map((ls) => ({
      ...ls,
      dateDebut: ligne.dateDebut,
      dateFin: ligne.dateFin,
      anneeSemaine: dispo.anneeSemaine,
    })) || [],
  };
  ligne.ligneReseau?.lignesCmdSelProduits?.forEach((ls) => {
    delete ls.id;
  });
}

export async function ajoutLignesCommandeProduitReseauLc(
  devisCommande, idProduit, idProduitAssocie, ordre, tauxTva,
) {
  const produitReseau = (await get(idProduit)).data.result;
  let liaisonTarif = [];
  if (idProduitAssocie !== null && produitReseau.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitReseau, idProduitAssocie, new Date());
  }
  if (!liaisonTarif) {
    const produitAssocie = (await getProduitAssocie(idProduitAssocie))
      .data.result;
    liaisonTarif = genererLiaisonTarifFromProduitAssocie(
      produitAssocie,
    );
  }
  const nouvelleLignesCommande = generationLigneCommandeRegroupement(
    produitReseau, liaisonTarif, devisCommande, tauxTva,
  );
  await mettreAJourLigneReseauAvecDispo(nouvelleLignesCommande);
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  genererCommentaireVenteForLigne(produitReseau, nouvelleLignesCommande);
  const affectationList = await getAffectionOfProductReseauLc([nouvelleLignesCommande]);
  updateAffection(
    nouvelleLignesCommande,
    devisCommande,
    affectationList[nouvelleLignesCommande.produitId],
  );
  if (devisCommande.type === TYPE_DEVIS) nouvelleLignesCommande.etatSouhaite = OPTION;
  return [nouvelleLignesCommande];
}

export async function ajoutLignesCommandeProduitReseauLcFromPlanningReseauLc(
  produitReseauId, produitLocation, date, typeDCF,
) {
  const produitReseau = (await get(produitReseauId)).data.result;
  let liaisonTarif = null;
  if (produitLocation && produitReseau.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitReseau, produitLocation.id, date.dateDebut);
  }
  if (!liaisonTarif) liaisonTarif = genererLiaisonTarifFromProduitAssocie(produitLocation);
  const ligne = generationLigneCommandeRegroupement(produitReseau, liaisonTarif, null);
  ligne.dateDebut = date.dateDebut;
  ligne.dateFin = date.dateFin;
  ligne.isFromDCF = false;
  await mettreAJourLigneReseauAvecDispo(ligne);
  setPrixUnitaireTlpe(ligne.lignesCommande.filter((ligneCommande) => {
    return ligneCommande.produit.produitDivers && ligneCommande.produit.produitDivers.tlpe
      && !ligneCommande.calculAutomatiqueTlpe;
  }), ligne.produit.liaisonsTarif);
  updateTarifProduitDiversTlpe(
    ligne.dateDebut,
    ligne.dateFin,
    ligne.lignesCommande.filter((ligneCommande) => {
      return ligneCommande.produit.produitDivers && ligneCommande.produit.produitDivers.tlpe
        && !ligneCommande.calculAutomatiqueTlpe;
    }),
  );
  genererCommentaireVenteForLigne(produitReseau, ligne);
  const affectationList = await getAffectionOfProductReseauLc([ligne]);
  updateAffection(ligne, { type: null }, affectationList[ligne.produitId]);
  if (typeDCF === TYPE_DEVIS) {
    ligne.etatSouhaite = OPTION;
  }
  try {
    await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key]);
    const parametresInterne = store.getters['parametres/parametresInterne'];
    const surPeriode = parametresInterne(PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key);
    await calculTlpe(ligne, typeDCF === TYPE_FACTURE, surPeriode);
  } catch (e) {
    ligne.lignesCommande.forEach((el) => {
      if (el.typeProduit === CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
        && el.produit.produitDivers.tlpe) {
        el.prixUnitaire = 0;
      }
    });
  }
  return ligne;
}
